import React from "react";
import { IoEyeOutline } from "@react-icons/all-files/io5/IoEyeOutline";

export default function OpenBtn() {
  return <IoEyeOutline fill="#ED8B00" stroke="#ED8B00" className="green-btn-plus" />;
}
